<template>
    <div class="m-log-manage">
        <h4 class="title">更新日志</h4>
        <h4 class="title">
            选择渠道
            <el-select class="select" size="small" @change="channelChange" v-model="channel" placeholder="请选择">
                <el-option
                    v-for="channel in channelList"
                    :key="channel.channelKey"
                    :label="channel.channelName"
                    :value="channel.channelKey">
                </el-option>
            </el-select>
        </h4>
        <div class="log-container">
            <div class="log-list">
                <div v-for="item in logList" class="item">
                	<div><span class="version">v{{item.baseVersion}}</span><span class="vtime">（{{timeFormat(item.vtime)}}）</span></div>
                	<ol>
                		<li v-for="it in item.newContentList">
                			<span class="text">{{it.text}}</span>
                			<el-button type="text" size="small" style="color: #8FA9FE;" v-if="it.docUrl" @click="openURL(it.docUrl)">查看详情</el-button>
                		</li>
                	</ol>
                </div>
        	</div>
            <el-pagination :total="total" :current-page.sync="pageNum" :page-size="pageSize" @current-change="getLogList" layout="->, prev, pager, next" prev-text="上一页" next-text="下一页" class="pager" background></el-pagination>
        </div>
	</div>
</template>
<script>
import dao from '@/lib/dao.js';

export default {
	data() {
		return {
			total: 0,
			pageNum: 1,
			pageSize: 20,
			logList: [],
            channelList: [],
            channel: ''
		}
	},
	methods: {
        getChannel(cb) {
            dao.shop.getChannel({
                miniappId: this.$route.params.appId,
                miniappType: 1
            }).then(data => {
                this.channelList = data.channelEnumModels;
                if(this.channelList.length) {
                    this.channel = this.channelList[0].channelKey
                }
                cb();
            }).catch(msg => this.$message.error(msg));
        },
        channelChange() {
            this.getLogList()
        },
        timeFormat(str) {
            let date = new Date(str);
            return date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate();
        },
		getLogList() {
            dao.shop.getAppletLogList({
                appId: this.$route.params.appId,
                channelUuid: this.channel,
                pageSize: this.pageSize,
                pageNum: this.pageNum
            }).then(data => {
                this.logList = data.list;
                this.total = data.total;
            }).catch(msg => {
                this.$message.error(msg);
            });
		},
		openURL(url) {
            this.$route.params.appId.indexOf('game') > -1
            ? window.open(`http://miniapp.bilibili.com/small-game-doc${url}`)
            : window.open(`http://miniapp.bilibili.com/small-app-doc${url}`);
		}
	},
	mounted() {
        this.getChannel(()=> {
            this.getLogList();
        })
	}
};
</script>
<style lang="less" scoped>
.m-log-manage {
	color: #5C667E;
	.title {
        font-size: 16px;
        font-weight: normal;
        margin: 0;
        margin-bottom: 15px;
    }
    .select {
        margin-left: 5px;
        width: 280px;
    }
    .log-container {
        padding: 10px 0 40px 20px;
        border: 1px solid #E0E5EC;
        background-color: #fff;
        //margin-bottom: 15px;
        height: 500px;
        z-index: 11;
        .log-list {
            height: 500px;
            overflow-y: scroll;
            .item {
                z-index: 9;
                &:last-child {
                    margin-bottom: 0;
                }
                .version {
                	font-size: 20px;
                    margin-right: 5px;
                }
                .vtime {
                	font-size: 16px;
                }
                .text {
                	font-size: 14px;
                	margin-right: 5px;
                }
            }
        }
        .pager {
            font-size: 12px;
            color: #9AA7C1;
            font-weight: normal;
            margin-right: 8px;
            .el-pager {
                .number {
                    background: #FFFFFF;
                    border: 1px solid rgba(154,167,193,0.50);
                    border-radius: 2px;
                    width: 30px;
                    height: 30px;
                    &.active {
                        background: #789AFF;
                        color: #fff;
                    }
                }
            }
            .btn-prev, .btn-next {
                border-radius: 2px;
                padding: 1px 11px;
                height: 30px;
                background: #FFFFFF;
                border: 1px solid rgba(154,167,193,0.50);
                
                &:disabled {
                    color: rgba(154,167,193,0.50);
                    background: #F7F8FB;
                    border: 1px solid rgba(154,167,193,0.20);
                }
                span {
                    font-size: 12px;
                }
                .more {
                    background: none;
                    color: #9AA7C1;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/manage/Log.vue